var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "side_menu_area" }, [
    _vm.enableSearch
      ? _c(
          "div",
          { staticClass: "search_word_area", class: _vm.searchWordAreaClass },
          [
            _c("span", { staticClass: "blind" }, [
              _vm._v(_vm._s(_vm.$t("gnb.search")))
            ]),
            _vm._v(" "),
            _c("form", [
              _c("div", { staticClass: "sizing_wrap" }, [
                _c(
                  "label",
                  {
                    staticClass: "btn_search",
                    attrs: { for: "inp_search" },
                    on: { click: _vm.showSearchInput }
                  },
                  [_vm._v(_vm._s(_vm.$t("gnb.enter_keyword")))]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "inp_search",
                  attrs: {
                    type: "text",
                    id: "inp_search",
                    placeholder: _vm.$t("gnb.enter_keyword"),
                    autocomplete: "off"
                  },
                  domProps: { value: _vm.searchInput.value },
                  on: {
                    keydown: function($event) {
                      if (
                        !("button" in $event) &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.search($event)
                    },
                    focusout: function($event) {
                      _vm.hideSearchInput(false)
                    },
                    input: _vm.updateSearchInputValue
                  }
                }),
                _vm._v(" "),
                _vm.isAvailableRestSearchInput
                  ? _c(
                      "button",
                      {
                        staticClass: "btn_search_reset",
                        attrs: { type: "reset" },
                        on: {
                          click: function($event) {
                            _vm.hideSearchInput(true)
                          }
                        }
                      },
                      [_vm._v("✕")]
                    )
                  : _vm._e()
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.enableChangeLocale
      ? _c(
          "div",
          {
            staticClass: "lang_select_area",
            on: {
              mouseover: function($event) {
                _vm.hoverMenu("locale", true)
              },
              mouseout: function($event) {
                _vm.hoverMenu("locale", false)
              }
            }
          },
          [
            _c("span", { staticClass: "blind" }, [
              _vm._v(_vm._s(_vm.$t("gnb.select_lang")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn_select_lang",
                on: {
                  mouseover: function($event) {
                    _vm.hoverMenu("locale", true)
                  }
                }
              },
              [
                _c("span", { staticClass: "blind" }, [
                  _vm._v(_vm._s(_vm.$t("gnb.selected_lang")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "select_lang_txt" }, [
                  _vm._v(_vm._s(_vm.userLocale.displayName))
                ])
              ]
            ),
            _vm._v(" "),
            _vm.hover.menus.locale
              ? _c(
                  "ul",
                  {
                    staticClass: "lst_lang is_show",
                    on: {
                      mouseover: function($event) {
                        _vm.hoverMenu("locale", true)
                      },
                      mouseout: function($event) {
                        _vm.hoverMenu("locale", false)
                      }
                    }
                  },
                  _vm._l(_vm.locales, function(locale) {
                    return _c(
                      "li",
                      {
                        key: locale.code,
                        staticClass: "lang_item",
                        class: {
                          is_selected: _vm.userLocale.code == locale.code
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn_lang",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.changeLocale(locale)
                              }
                            }
                          },
                          [_vm._v(_vm._s(locale.displayName))]
                        )
                      ]
                    )
                  })
                )
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.enableNewsletter
      ? _c(
          "a",
          {
            staticClass: "link_newsletter",
            attrs: { href: _vm.newsletterUrl, target: "_blank" }
          },
          [_vm._v(_vm._s(_vm.$t("gnb.newsletter")))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.enableUserMenu && _vm.isEmpty(_vm.session.uuid)
      ? _c("ul", { staticClass: "lst_member_link" }, [
          _c("li", { staticClass: "link_item" }, [
            _c(
              "a",
              {
                staticClass: "link_txt",
                attrs: { href: _vm.getToastIdUrl("login") }
              },
              [_vm._v(_vm._s(_vm.$t("gnb.signin")))]
            )
          ]),
          _vm._v(" "),
          _vm.joinButton.show != false
            ? _c("li", { staticClass: "link_item" }, [
                _c(
                  "a",
                  {
                    staticClass: "link_txt",
                    attrs: {
                      href: _vm.isEmpty(_vm.joinButton.url)
                        ? _vm.getToastIdUrl("join")
                        : "" + this.getDomain("toastId") + _vm.joinButton.url
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("gnb.join")) + "\n      "
                    )
                  ]
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.enableUserMenu && _vm.exist(_vm.session.uuid)
      ? _c(
          "div",
          {
            staticClass: "member_setting_area",
            on: {
              mouseover: function($event) {
                _vm.hoverMenu("session", true)
              },
              mouseout: function($event) {
                _vm.hoverMenu("session", false)
              }
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "btn_member_setting",
                attrs: { href: "javascript:;" }
              },
              [_vm._v(_vm._s(_vm.session.maskedEmail))]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hover.menus.session,
                    expression: "hover.menus.session"
                  }
                ],
                staticClass: "lst_member_setting is_show",
                on: {
                  mouseout: function($event) {
                    _vm.hoverMenu("session", false)
                  }
                }
              },
              [
                _c("li", { staticClass: "setting_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link_txt",
                      attrs: {
                        href: this.memberInfoUrl,
                        target: _vm.isDefaultSetting ? "_self" : "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("gnb.profile")))]
                  )
                ]),
                _vm._v(" "),
                _vm.envs.account.loginSecurity.enabled
                  ? _c("li", { staticClass: "setting_item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "link_txt",
                          attrs: {
                            href: this.memberLoginSecurityUrl,
                            target: _vm.isDefaultSetting ? "_self" : "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("gnb.login-security")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.marketplaceEnabled
                  ? _c(
                      "li",
                      { staticClass: "setting_item" },
                      [
                        _c(
                          "router-link-ex",
                          {
                            staticClass: "link_txt",
                            attrs: {
                              to: _vm.countryPath + "/account/marketplace",
                              domain: _vm.getDomain("homepage")
                            }
                          },
                          [
                            _c("span", { staticClass: "menu_txt" }, [
                              _vm._v(_vm._s(_vm.$t("gnb.marketplace.title")))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.envs.edu.enabled && !this.isJp
                  ? _c(
                      "li",
                      { staticClass: "setting_item" },
                      [
                        _c(
                          "router-link-ex",
                          {
                            staticClass: "link_txt",
                            attrs: {
                              to: _vm.countryPath + "/account/edu",
                              domain: _vm.getDomain("homepage")
                            }
                          },
                          [
                            _c("span", { staticClass: "menu_txt" }, [
                              _vm._v(_vm._s(_vm.$t("gnb.edu.title")))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "setting_item" },
                  [
                    _c(
                      "router-link-ex",
                      {
                        staticClass: "link_txt",
                        attrs: {
                          to: _vm.countryPath + "/account/payment",
                          domain: _vm.getDomain("homepage")
                        }
                      },
                      [
                        _c("span", { staticClass: "menu_txt" }, [
                          _vm._v(_vm._s(_vm.$t("gnb.payment_info")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "setting_item" },
                  [
                    _c(
                      "router-link-ex",
                      {
                        staticClass: "link_txt",
                        attrs: {
                          to: _vm.countryPath + "/account/credit",
                          domain: _vm.getDomain("homepage")
                        }
                      },
                      [
                        _c("span", { staticClass: "menu_txt" }, [
                          _vm._v(_vm._s(_vm.$t("gnb.credit")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "setting_item" },
                  [
                    _c(
                      "router-link-ex",
                      {
                        staticClass: "link_txt",
                        attrs: {
                          to: _vm.countryPath + "/account/terms",
                          domain: _vm.getDomain("homepage")
                        }
                      },
                      [
                        _c("span", { staticClass: "menu_txt" }, [
                          _vm._v(_vm._s(_vm.$t("gnb.mypage.terms")))
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "setting_item has_top_line" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link_txt",
                      attrs: {
                        href: _vm.getDomain("console") + "/billing",
                        target: "_blank"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("gnb.billing")))]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "setting_item has_top_line" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link_txt",
                      attrs: { href: _vm.getToastIdUrl("logout") }
                    },
                    [_vm._v(_vm._s(_vm.$t("gnb.signout")))]
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }